// IMPORTS
import _ from 'lodash'
import axios from 'axios'
import mobiscroll from '@mobiscroll/javascript'

// DEFINITIONS
const updatingAPI = 'orders/getmine'

const state = {
	index: []
}

const getters = {
    pedidosGetIndex: state => {
        return state.index
    }
}

const mutations = {
	pedidosSetIndex: (state, payload) => {
        state.index = payload
    }
}

const actions = {
	pedidosUpdate: async ({commit}) => {
        try {
            let response = await axios.get(updatingAPI)
            if(response.status){
                commit('pedidosSetIndex', response.data)
            }
        } catch(e){
            console.error(e)
            mobiscroll.snackbar({
                display: 'top',
                theme: 'ios',
                message: 'Ocurrió un error obteniendo la respuesta: ' + e,
                color: 'warning',
                duration: 7000
            })
        }
    }
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};